/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Cut_LeadInputs */

const en_for_whom_cut_lead = /** @type {(inputs: For_Whom_Cut_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shape without guesswork.`)
};

const pl_for_whom_cut_lead = /** @type {(inputs: For_Whom_Cut_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sylwetka bez zgadywania.`)
};

/**
* | output |
* | --- |
* | "Shape without guesswork." |
*
* @param {For_Whom_Cut_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_cut_lead = /** @type {((inputs?: For_Whom_Cut_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Cut_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_cut_lead(inputs)
	return en_for_whom_cut_lead(inputs)
});